module.exports = __webpack_public_path__ + "static/media/resposta-curta-icon.3d9f5b97.svg";